import { useState, useEffect } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { MessageCircle, Sparkles } from "lucide-react";
import { demoEvent, demoBuddy } from "@/data/tourDemoData";
import confetti from "canvas-confetti";

export const DemoBuddyMatch = () => {
  const [showMatch, setShowMatch] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowMatch(true);
      // Trigger confetti
      confetti({
        particleCount: 80,
        spread: 60,
        origin: { y: 0.6 },
        colors: ['#F97316', '#FCD34D', '#10B981', '#3B82F6'],
      });
    }, 800);

    return () => clearTimeout(timer);
  }, []);

  if (!showMatch) {
    return (
      <Card className="w-full max-w-sm mx-auto p-6 bg-card">
        <div className="flex flex-col items-center gap-4">
          <div className="w-16 h-16 rounded-full bg-primary/20 animate-pulse flex items-center justify-center">
            <Sparkles className="w-8 h-8 text-primary animate-spin" />
          </div>
          <p className="text-muted-foreground">Finding your buddy...</p>
        </div>
      </Card>
    );
  }

  return (
    <Card className="w-full max-w-sm mx-auto p-5 bg-card animate-scale-in">
      <div className="space-y-4">
        <div className="text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-green-500/20 text-green-600 rounded-full text-sm font-medium mb-3">
            <Sparkles className="w-4 h-4" />
            It's a Match!
          </div>
          <h3 className="font-semibold text-lg text-foreground">You're going with...</h3>
        </div>

        <div className="flex items-center gap-4 p-4 bg-primary/5 rounded-xl border border-primary/20">
          <Avatar className="w-14 h-14 ring-2 ring-primary ring-offset-2 ring-offset-background">
            <AvatarImage src={demoBuddy.avatar} />
            <AvatarFallback className="bg-primary/20 text-primary font-semibold">
              {demoBuddy.name.slice(0, 1)}
            </AvatarFallback>
          </Avatar>
          
          <div className="flex-1">
            <p className="font-semibold text-foreground">{demoBuddy.name}</p>
            <p className="text-sm text-muted-foreground">Your buddy for {demoEvent.title}</p>
          </div>
        </div>

        <Button className="w-full gap-2 font-semibold" size="lg">
          <MessageCircle className="w-4 h-4" />
          Message {demoBuddy.name.split(' ')[0]}
        </Button>

        <p className="text-xs text-center text-muted-foreground">
          A conversation has been started automatically 💬
        </p>
      </div>
    </Card>
  );
};
